import { asyncRouterHandle } from '@/utils/asyncRouter';
import { fetchMenuList } from '@/api/menu';
const routerList = [];

/**
 * 后端常见数据问题：
 * 1) 顶层 layout 的 path 为 "" —— path.resolve('', x) 在侧栏里会拼错，vue-router 也宜使用 "/"
 * 2) 父子 route.name 相同（如两个 dashboard）—— Vue Router 要求 name 全局唯一，会告警或覆盖
 */
function normalizeBackendRoutes(routes) {
  if (!routes || !routes.length) return;
  routes.forEach(route => {
    if (route.path === '' || route.path === undefined) {
      route.path = '/';
    }
    if (route.children && route.children.length) {
      normalizeBackendRoutes(route.children);
      const dup = route.children.some(c => c.name && c.name === route.name);
      if (dup && route.name) {
        route.name = `layout_${route.id}_${route.name}`;
      }
    }
  });
}
const formatRouter = routes => {
  routes && routes.map(item => {
    if ((!item.children || item.children.every(ch => ch.hidden)) && item.name !== '404') {
      routerList.push({
        label: item.meta.title,
        value: item.name
      });
    }
    item.hidden = item.meta && item.meta.hidden;
    if (item.children && item.children.length > 0) {
      formatRouter(item.children);
    } else {
      delete item.children;
    }
  });
};
export default {
  namespaced: true,
  state: {
    asyncRouters: [],
    routerList: routerList
  },
  mutations: {
    setRouterList(state, routerList) {
      state.routerList = routerList;
    },
    // 设置动态路由
    setAsyncRouter(state, asyncRouters) {
      state.asyncRouters = asyncRouters;
    }
  },
  actions: {
    // 从后台获取动态路由
    async SetAsyncRouter({
      commit
    }) {
      const asyncRouterRes = await fetchMenuList();
      const asyncRouter = asyncRouterRes.data;
      routerList.length = 0;
      normalizeBackendRoutes(asyncRouter);
      formatRouter(asyncRouter);
      asyncRouter.push({
        path: '/login/:token',
        component: 'views/login/index.vue',
        hidden: true
      });
      asyncRouter.push({
        path: '/iframe',
        component: 'layout',
        hidden: true,
        children: [{
          path: 'go',
          name: 'iframe',
          component: 'views/iframe.vue',
          hidden: true
        }]
      });
      // 必须挂在 layout 下，否则不会渲染 LayoutIndex，侧栏不会出现
      asyncRouter.push({
        path: '/user-business-voucher',
        component: 'layout',
        children: [{
          path: '',
          name: 'userBusinessVoucher',
          component: 'views/transaction/userBusinessVoucher.vue'
        }]
      });
      asyncRouter.push({
        path: '*',
        redirect: '/404',
        hidden: true
      });
      asyncRouterHandle(asyncRouter);
      commit('setAsyncRouter', asyncRouter);
      commit('setRouterList', routerList);
      return true;
    }
  },
  getters: {
    // 获取动态路由
    asyncRouters(state) {
      return state.asyncRouters;
    },
    routerList(state) {
      return state.routerList;
    }
  }
};